import React from 'react';
import { motion } from 'framer-motion';
import { TrustBadge } from './TrustBadge';
interface EBTFilterProps {
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
}
export function EBTFilter({
  isEnabled,
  onToggle
}: EBTFilterProps) {
  return <div className="flex items-center justify-between bg-white p-4 rounded-xl border border-gray-200 shadow-sm" data-id="element-199">
      <div className="flex items-center gap-3" data-id="element-200">
        <TrustBadge type="EBT" size="sm" data-id="element-201" />
        <span className="font-bold text-gray-900 text-sm" data-id="element-202">
          EBT Eligible Only
        </span>
      </div>

      <button onClick={() => onToggle(!isEnabled)} className={`relative w-12 h-7 rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 ${isEnabled ? 'bg-cyan-600' : 'bg-gray-300'}`} aria-pressed={isEnabled} aria-label="Toggle EBT eligible products only" data-id="element-203">
        <motion.div className="absolute top-1 left-1 w-5 h-5 bg-white rounded-full shadow-md" animate={{
        x: isEnabled ? 20 : 0
      }} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30
      }} data-id="element-204" />
      </button>
    </div>;
}